import { render, staticRenderFns } from "./evaluate-project-student.vue?vue&type=template&id=8ed7d8c6&scoped=true"
import script from "./evaluate-project-student.vue?vue&type=script&lang=js"
export * from "./evaluate-project-student.vue?vue&type=script&lang=js"
import style0 from "./evaluate-project-student.vue?vue&type=style&index=0&id=8ed7d8c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed7d8c6",
  null
  
)

export default component.exports